import React from "react";
import ModelPanel from "./ModelPanel";
import ScenePanel from "./ScenePanel";
import { useClient } from "../../shared/hooks/client-hook";

const Panel = () => {
  const { currentTool } = useClient();

  if (currentTool === "scene") {
    return <ScenePanel />;
  }

  return <ModelPanel />;
};

export default Panel;
